module.exports = __webpack_public_path__ + "52d80f2a894ec032b9f0d0509a53afbf.png";